export default "__VITE_ASSET__CiE7IltU__"